import useProfileData from "./hooks/useProfileData";
import ReviewsSection from "./ReviewsSection";
import ReviewsForm from "./ReviewsForm";
import ContractSection from './ContractSection';
import styles from './styles/HouseManagerProfile.module.css'
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faStar, faMessage  } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";

import Messagingmodal from '../Messaging'
const baseURL = `${process.env.REACT_APP_API_URL}`

export default function ProfileHeader() {
    const { profile, loading, error } = useProfileData();
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [isMessagingOpen, setIsMessagingOpen] = useState(false)
    const [message, setMessage] = useState('');
    const [contract, setContract] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);


    const location = useLocation()
    const { id } = useParams();

    const handleImageClick = () => setIsImageModalOpen(true)
    const handleCloseImageModal = () => setIsImageModalOpen(false)
    const [showContactForm, setShowContactForm] = useState(false);

     const userType = location.pathname.includes("house_manager") ? "house_manager" : "employer";

    const openMessagingModal = () => {
        setIsMessagingOpen(true);
    };

    const closeMessagingmodal = () => {
        setIsMessagingOpen(false);
    }

    const handleOpenModal = () => setIsModalOpen(true)
    const handleCloseModal = () => setIsModalOpen(false)


    const handleSendMessage = () => {
        if (!message.trim()) {
            console.error('Message cannot be empty')
            return;
        }
        const token = localStorage.getItem('accessToken');
        if (!token) {
            console.error('AccessToken not found in localStorage');
        }
        console.log('AccessToken:', token)
        axios
            .post(
            `${baseURL}/profiles/contact-house-manager/`,
            {
                houseManagerId: id,
                message,
            },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            )
            .then(() => {
            // setSuccess("Message sent successfully");
            setMessage("");
            setShowContactForm(false);
            })
            .catch((error) => {
            console.error('Error sending message:', error)
            if (error.response && error.response.status === 401) {
                console.error("Unauthorized: Please log in again")
            } else {
                console.error("Error has occurred while sending your message");
            }
            });

    };


    if(loading) return <div>Loading Profile ...</div>
    if(error) return <div>{error}</div>
    if(!profile) return <div>No profile found</div>

    return (
        <>
            <Messagingmodal 
                isOpen={isMessagingOpen}
                onClose={closeMessagingmodal}
                recipientId={profile.user_id}
                recipientName={`${profile.first_name} ${profile.last_name}`}
            />

            {isImageModalOpen && (
            <div className={styles.imageModal}>
                <div className={styles.imageModalContent}>
                <button
                    className={styles.closeButton}
                    onClick={handleCloseImageModal}
                >
                    &times;
                </button>
                <img 
                    src={`${baseURL}${profile.image}`}
                    alt={`${profile.first_name} ${profile.last_name}`}
                    className={styles.fullSizeImage}
                />
                </div>
            </div>
            )}

            <div className={styles.header}>
            <div className={styles.leftSection}>
                <div className={styles.subHeader}>
                <img
                    src={`${baseURL}${profile.image}`}
                    alt={`${profile.first_name} ${profile.last_name}`}
                    className={styles.profileImage}
                    onClick={handleImageClick}
                />
                <div className={styles.basicInfo}>
                    <h1 className={styles.name}>
                    {profile.first_name} {profile.last_name}
                    </h1>
                    <p className={styles.location}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{color: '#007bff'}}/> {profile.location}
                    </p>
                    <p className={styles.rating}>
                    <FontAwesomeIcon icon={faStar} style={{color: '#f39c12'}}/> {profile.rating.toFixed(1)}/5
                    </p>
                    <button
                    className={styles.contactButton}
                    onClick={() => setShowContactForm(true)}
                    >
                    Contact Me
                    </button>
                    <span className={styles.messageButton} onClick={openMessagingModal}>
                    <FontAwesomeIcon icon={ faMessage } style={{color: '#f39c12', fontSize: '30px'}}/>
                    <FontAwesomeIcon icon="fa-solid fa-message" />
                    </span>
                </div>
                
                </div>
                <div className={styles.shareSection}>
                    <h3>Share {profile.first_name} Profile</h3>
                    <div className={styles.shareIcons}>
                    <div>
                        <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                            `http://localhost:3000/profile/house_manager/${profile.id}`
                        )}&text=Check out ${profile.first_name}'s profile!`}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        <FontAwesomeIcon icon={faTwitter} className={styles.shareIcon} />
                        </a>
                    </div>
                    <div>
                        <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                            `http://localhost:3000/profile/house_manager/${profile.id}`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        <FontAwesomeIcon icon={faFacebook} className={styles.shareIcon} />
                        </a>
                    </div>
                    <div>
                        <a
                        href={`https://www.tiktok.com/share?url=${encodeURIComponent(
                            `http://localhost:3000/profile/house_manager/${profile.id}`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        <FontAwesomeIcon icon={faTiktok} className={styles.shareIcon} />
                        </a>
                    </div>
                    <div>
                        <a
                        href={`https://www.instagram.com/?url=${encodeURIComponent(
                            `http://localhost:3000/profile/house_manager/${profile.id}`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        <FontAwesomeIcon icon={faInstagram} className={styles.shareIcon} />
                        </a>
                    </div>
                    <div>
                        <a
                        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                            `Check out ${profile.first_name}'s profile: http://localhost:3000/profile/house_manager/${profile.id}`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        <FontAwesomeIcon icon={faWhatsapp} className={styles.shareIcon} />
                        </a>
                    </div>
                    </div>
                </div>
                <ReviewsForm />
                
                <ContractSection />
            </div>
                { showContactForm && (
                    <div className={styles.contactForm}>
                    <h2>Contact {profile.first_name}</h2>
                    <textarea
                        className={styles.messageInput}
                        placeholder="Write your message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                    <div className={styles.formButton}>
                        <button className={styles.sendButton} onClick={handleSendMessage}>
                        Send Message
                        </button>
                        <button className={styles.cancelButton} onClick={() => setShowContactForm(false)}>
                        Cancel
                        </button>
                    </div>
                    </div>
                ) }
            <ReviewsSection />            
        </div>
        </>
        
    )
}